// Port of api/fuel/app/classes/filter/search/games/rules/query/date_rated.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'date_rated',
	field: function() { return 'MAX(r.rating_date)' }
})
